<template>
  <apexchart
    :ref="refChart"
    type="bar"
    height="350"
    :options="options"
    :series="series"
  ></apexchart>
</template>

<script>
export default {
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    refChart: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: {
        chart: {
          width: "100%",
          toolbar: {
            show: false,
          },
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  watch: {
    series() {
      const me = this;
      me.updateChart();
    },
    categories() {
      const me = this;
      me.updateChart();
    },
  },
  methods: {
    updateChart() {
      const me = this;
      const chart = me.$refs[me.refChart];
      chart.updateOptions({
        xaxis: {
          categories: me.categories,
        },
      });
      chart.updateSeries(me.series);
    },
  },
  created() {
    const me = this;
    me.options.title.text = me.title;
  },
  mounted() {
    const me = this;
    me.options.xaxis.categories = me.categories;
  },
};
</script>

<style lang="scss" scoped></style>
